import * as React from 'react';
import { v1 as uuidv1, v4 as uuidv4 } from 'uuid';
import { BestDeterminer } from '../../lib/determiner';
import { BaseRow, BaseRowFactory } from '../BaseRow';

export class UUIDRow extends BaseRow<UUIDRowFactory> {
  renderData() {
    if (this.props.input.version === 0) {
      const value = this.props.data.value.toLowerCase();
      const val = (start: number, length: number) => value.substr(start, length).replace(/^0+/, "") || "0"
      return <>
        <span>{`{${value.toUpperCase()}}`}</span><br />
        <span>{``}</span><br/>
        <span>{`IMPLEMENT_OLECREATE(<<class>>, <<external_name>>,`}</span><br />
        <span>{`0x${val(0, 8)}, 0x${val(9, 4)}, 0x${val(14, 4)}, 0x${val(19, 2)}, 0x${val(21, 2)}, 0x${val(24, 2)}, 0x${val(26, 2)}, 0x${val(28, 2)}, 0x${val(30, 2)}, 0x${val(32, 2)}, 0x${val(34, 2)});`}</span><br />
        <span>{``}</span><br />
        <span>{`DEFINE_GUID(<<name>>,`}</span><br />
        <span>{`0x${val(0, 8)}, 0x${val(9, 4)}, 0x${val(14, 4)}, 0x${val(19, 2)}, 0x${val(21, 2)}, 0x${val(24, 2)}, 0x${val(26, 2)}, 0x${val(28, 2)}, 0x${val(30, 2)}, 0x${val(32, 2)}, 0x${val(34, 2)});`}</span><br />
        <span>{``}</span><br />
        <span>{`static const GUID <<name>> =`}</span><br />
        <span>{`{ 0x${val(0, 8)}, 0x${val(9, 4)}, 0x${val(14, 4)}, { 0x${val(19, 2)}, 0x${val(21, 2)}, 0x${val(24, 2)}, 0x${val(26, 2)}, 0x${val(28, 2)}, 0x${val(30, 2)}, 0x${val(32, 2)}, 0x${val(34, 2)} } };`}</span><br />
      </>
    }
    return <span>{this.props.data.value}</span>
  }
}

export class UUIDRowFactory extends BaseRowFactory<typeof UUIDRow, { value: string }, {
  version: number
}> {
  generate(input: this['TInput']) {
    let result = ""
    switch (input.version) {
      case 0:
      case 4:
        result = uuidv4({
          rng: () => {
            return Array.from(BestDeterminer.bytes(16))
          }
        })
        break;
      case 1:
        result = uuidv1();
        break;
    }
    return {
      value: result
    }
  }

  component = UUIDRow
}
